import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: 5,
				"&:active": {
					cursor: "pointer",
					opacity: 0.7
				}
			},
			btnPromotion: {
				background: theme.palette.secondary.main,
				borderRadius: 2,
				fontSize: 12,
				display: "flex",
				alignItems: "center",
				justifyContent: "space-around",
				height: 25,
				position: "relative",
				color: theme.palette.common.white
			},
			borderLeft: {
				width: 10,
				height: 10,
				position: "absolute",
				left: -5,
				borderRadius: "50%",
				background: theme.palette.common.white
			},
			borderRight: {
				width: 10,
				height: 10,
				position: "absolute",
				right: -5,
				borderRadius: "50%",
				background: theme.palette.common.white
			},
			cart: {
				background: theme.palette.primary.main,
				padding: "8px 15px",
				borderRadius: "17px 0px 6px",
				textAlign: "center",
				color: theme.palette.primary.contrastText,
				"&:active": {
					cursor: "pointer",
					opacity: 0.7
				}
			}
		}),
	{
		name: "ProductItemFooter",
		index: 1
	}
);

export default useStyles;
